/* eslint-disable max-len */
import React, { useState } from 'react';
import $ from 'jquery';
import { Button, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CheckBoxs from './CheckBoxs';
import { soTableColor, soSettingIcon, soResetIcon } from '../../shared/assets/images';
import {
  soIonsObj, soStreamPropObj, soSaturationDataObj, srcDest,
  setUpdatedIonsAr, getUpdatedIonsAr, setUpdatedStreamPropAr, getUpdatedStreamPropAr,
  setUpdatedSaturationDataAr, getUpdatedSaturationDataAr, setUpdatedSrcDectAr, getUpdatedSrcDectAr
} from './soHelper';
import './StreamOverlaySetting.scss';
import { setStreamDataProp, DefaultsSreamDataProp } from '../userData';

const StreamOverlaySetting = (props) => {

  const { setReqPropAr, setOverlayDisplay } = props;
  const { t } = useTranslation();
  const defIons = getUpdatedIonsAr(); // Which checkBox will be already checked
  const [Ions, setIons] = useState([...defIons]);

  const defStreamProp = getUpdatedStreamPropAr();
  const [streamProp, setStreamProp] = useState([...defStreamProp]);

  const defSatdata = getUpdatedSaturationDataAr();
  const [satData, setSatData] = useState([...defSatdata]);

  const defsd = getUpdatedSrcDectAr();
  const [srcDect, setSrcDect] = useState([...defsd]);

  // Defining the priority Array
  const prtsrcDect = ['streamName', 'source', 'destination'];  // 1
  const prtStreamPropObj = ['flow', 'temp', 'press', 'tds', 'ph', 'malk', 'hardness', 'density', 'ionic_str', 'toc']; // 2
  const prtsatData = ['baso4', 'caf2', 'caso4', 'sio2', 'srso4', 'struvite', 'lsi', 'sdi', 'mgoh2', 'osmotic_pressure', 'conductivity']; // 3
  const prtIons = ['Ca++', 'Mg++', 'Na+', 'K+', 'NH4+', 'Ba++', 'Sr++', 'Fe++', 'Mn++', 'SO4--', 'Cl-', 'F-', 'NO3-', 'Br-', 'PO4---', 'B-', 'SiO2',
    'H2S', 'HCO3-', 'CO2', 'CO3--']; // 4

  // Take PriorityArr and normal arr => return priority based arr
  const priorityFun = (priorityAr, Arr) => {
    const resAr = [];

    for (let i = 0; i < priorityAr.length; i += 1) {
      if (Arr.includes(priorityAr[i]))
        resAr.push(priorityAr[i]);
    }
    return resAr;
  };

  // Button
  const handleUpdate = () => {
    $('.setingImg').attr('src', soSettingIcon);
    $('.tableImg').attr('src', soTableColor);

    // save the checkbox checked if we run 2nd file so on..
    setUpdatedSrcDectAr(srcDect);
    setUpdatedStreamPropAr(streamProp);
    setUpdatedSaturationDataAr(satData);
    setUpdatedIonsAr(Ions);

    // set the sequence of proprties in Table view (1st Column)
    const priorityFunArr = [...priorityFun(prtsrcDect, srcDect), ...priorityFun(prtStreamPropObj, streamProp), ...priorityFun(prtsatData, satData), ...priorityFun(prtIons, Ions)];
    setStreamDataProp(priorityFunArr);
    setReqPropAr(priorityFunArr);
    setOverlayDisplay({ tableView: true, settingView: false });
    $('#settingView').hide();
    $('#tableView').show();
  };

  const handleReset = () => {
    $('.setingImg').attr('src', soSettingIcon);
    $('.tableImg').attr('src', soTableColor);
    // setStreamDataProp(); // reset in userData : doing below one more time

    // save the checkbox checked if we run 2nd file so on..
    // setUpdatedSrcDectAr(['source', 'destination']);
    setUpdatedSrcDectAr(['streamName']);
    setUpdatedStreamPropAr(['flow', 'press', 'tds', 'ph', 'malk', 'hardness', 'density']);
    setUpdatedSaturationDataAr(['osmotic_pressure', 'conductivity']);
    setUpdatedIonsAr([]);

    // reset pe change pehale se checked checkbox
    setIons([]);
    setStreamProp(['flow', 'press', 'tds', 'ph', 'malk', 'hardness', 'density']);
    setSatData(['osmotic_pressure', 'conductivity']);
    // setSrcDect(['source', 'destination']);
    setSrcDect(['streamName']);

    // set the sequence of proprties in Table view (1st Column): Change to defalut
    const priorityFunArr = DefaultsSreamDataProp;
    setStreamDataProp(priorityFunArr); // update in userData, this will change to defalut
    setReqPropAr(priorityFunArr); // set the array of table props

    setOverlayDisplay({ tableView: true, settingView: false });
    $('#settingView').hide();
    $('#tableView').show();
  };

  return (
    <div id='settingView' className='soSettingGridContainer' style={{ 'display': 'none' }}>
      <span className='tsText'>{t('Table Setting')}</span>
      <div className='propsContainers'>
        <div className='sepratecheckbox'>
          <CheckBoxs
            propArr={soIonsObj} // Array of all checkBox in this Ionic Comp
            selectAllTxt={t('Ionic Composition')}
            checkBxsChecked={Ions} // which Ions will be checked pehale se hi
            setCheckBxsChecked={setIons} />
        </div>
        <div className='sepratecheckbox'>
          <CheckBoxs
            propArr={soStreamPropObj}
            selectAllTxt={t('Stream Properties')}
            checkBxsChecked={streamProp}
            setCheckBxsChecked={setStreamProp} />
        </div>
        <div className='sepratecheckbox'>
          <CheckBoxs
            propArr={soSaturationDataObj}
            selectAllTxt={t('Saturation Data')}
            checkBxsChecked={satData}
            setCheckBxsChecked={setSatData} />
        </div>
        <div className='sepratecheckbox'>
          <CheckBoxs
            propArr={srcDest}
            selectAllTxt='SrcDect'
            checkBxsChecked={srcDect}
            setCheckBxsChecked={setSrcDect} />
          <div id='updateButton-resetImg'>
            <Button
              variant="contained"
              size="small"
              id='updateSetingBtn'
              className="sansW4SeLig"
              onClick={handleUpdate}>
              {t('Update')}
            </Button>
            <Tooltip title='Reset' placement='top' arrow>
              <div id='resetSetting' onClick={handleReset}>
                <img className='resetSettingImg' src={soResetIcon} alt="so_resetSettingImg" />
              </div>
            </Tooltip>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StreamOverlaySetting;